module.exports = __webpack_public_path__ + "img/Curacao.8144e2c1.svg";